import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";

type Props = {
  path?: string;
  heading?: string;
  paragraph?: string;
  className?: string;
  ImgClass?: string;
  TopClass?: string;
  headingClass?: string;
  paragraphClass?: string;
  explore?: string;
  to?: any;
};

const GraphDataOnRight = ({
  path,
  heading,
  paragraph,
  className,
  ImgClass,
  TopClass,
  headingClass,
  paragraphClass,
  explore,
  to,
}: Props) => {
  return (
    <div className={`${className} section4 container px-30`}>
      <div className="row card-container1 col-md-12 col-sm-12 col-lg-12 ">
        {/* <div className="col-md-1" /> */}
        <div
          className={`container-fluid row col-lg-6 col-md-12 d-none d-md-block`}
        >
          <img className="w-100" src={path} alt={"Garph on left"} />
        </div>
        <div
          className={`${TopClass} container-fluid col-lg-5 col-md-12 align-self-center`}
        >
          <p
            className={`${headingClass} text-white font-26 font-family-roboto-flex fonts-800 line-30 pb-20 garph-heading`}
          >
            {heading}
          </p>
          <p
            className={`${paragraphClass} text-align-left text-white-20 font-family-roboto font-16 fonts-400 pb-20 line-18 graph-subheading`}
          >
            {paragraph}
          </p>
          <div className="d-block d-md-none">
            {explore && (
              <Link to={to}>
                {" "}
                <div className="expoler-btn">
                  <Button
                    textclass="fonts-500 font-family-roboto-flex font-16 line-18 justify-content-center"
                    className="text-color-success wx-90 hx-30 d-flex align-items-center justify-content-center d-block d-md-none"
                    text={explore}
                  />
                </div>
              </Link>
            )}
          </div>
          <div className="d-none d-md-block">
            {explore && (
              <Link to={to}>
                <div className="text-color-success wx-147 hx-40 d-flex align-items-center justify-content-center">
                  <Button
                    textclass="fonts-500 font-family-roboto-flex font-16 line-18 justify-content-center"
                    className="text-color-success wx-147 hx-40 d-flex align-items-center justify-content-center d-none d-md-block"
                    text={explore}
                    ui-button
                  />
                </div>
              </Link>
            )}
          </div>
        </div>
        <div
          className={`container-fluid row col-lg-6 col-md-12 d-block d-md-none`}
        >
          <img className="w-100" src={path} alt={"Garph on left"} />
        </div>
      </div>
    </div>
  );
};

export default GraphDataOnRight;

GraphDataOnRight.defaultProps = {
  path: "",
  heading: "",
  paragraph: "",
  className: "",
};
